export const navigationLinks = [
  { label: '首页', href: '/', icon: 'ri-home-4-line' },
  { label: '游戏分类', href: '/categories', icon: 'ri-gamepad-line' },
  { label: '游戏资讯', href: '/articles', icon: 'ri-article-line' },
  { label: '关于我们', href: '/about', icon: 'ri-information-line' },
];

export const gameCategories = [
  {
    id: 'dou-di-zhu',
    name: '斗地主',
    icon: 'ri-gamepad-line',
    description: '经典三人斗地主，欢乐竞技，体验地道的中国扑克玩法',
    playerCount: '2-3人',
    difficulty: '简单',
    popularity: 98,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20playing%20cards%20dou%20dizhu%20game%20scene%20with%20golden%20red%20theme%2C%20traditional%20Chinese%20style%2C%20warm%20lighting%2C%20elegant%20game%20table%20with%20cards%20spread%2C%20luxurious%20casino%20style%2C%20dark%20wood%20background%2C%20dramatic%20lighting&width=800&height=600&seq=game-ddzh-01&orientation=landscape',
    features: ['经典三人玩法', '多种加倍选择', '免费欢乐豆', '实时语音聊天'],
  },
  {
    id: 'ma-jiang',
    name: '麻将',
    icon: 'ri-stack-line',
    description: '国粹麻将，多种地方玩法汇聚一堂，随时随地开桌搓麻',
    playerCount: '2-4人',
    difficulty: '中等',
    popularity: 96,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20mahjong%20table%20with%20green%20felt%20surface%2C%20mahjong%20tiles%20scattered%2C%20warm%20ambient%20lighting%2C%20elegant%20oriental%20decor%2C%20dark%20wood%20interior%2C%20luxurious%20gaming%20room%20atmosphere&width=800&height=600&seq=game-mj-01&orientation=landscape',
    features: ['国标麻将', '四川麻将', '广东麻将', '二人麻将'],
  },
  {
    id: 'de-zhou-pu-ke',
    name: '德州扑克',
    icon: 'ri-hearts-line',
    description: '国际经典德州扑克，专业赛事体验，与世界玩家同台竞技',
    playerCount: '2-9人',
    difficulty: '进阶',
    popularity: 94,
    image: 'https://readdy.ai/api/search-image?query=Professional%20Texas%20holdem%20poker%20table%20with%20chips%20and%20cards%2C%20luxurious%20green%20felt%20table%2C%20golden%20poker%20chips%2C%20dramatic%20lighting%2C%20dark%20elegant%20room%2C%20casino%20atmosphere%2C%20professional%20gaming%20scene&width=800&height=600&seq=game-dzpk-01&orientation=landscape',
    features: ['无限注玩法', '锦标赛模式', '快速桌', 'VIP专属房'],
  },
  {
    id: 'bai-jia-le',
    name: '百家乐',
    icon: 'ri-vip-diamond-line',
    description: '经典百家乐玩法，简洁流畅，体验贵族般的高端博彩乐趣',
    playerCount: '多人',
    difficulty: '简单',
    popularity: 92,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20baccarat%20table%20in%20luxurious%20casino%20setting%2C%20golden%20and%20crimson%20decor%2C%20playing%20cards%20and%20chips%2C%20warm%20ambient%20lighting%2C%20sophisticated%20gaming%20atmosphere%2C%20dark%20wood%20and%20velvet%20textures&width=800&height=600&seq=game-bjl-01&orientation=landscape',
    features: ['庄闲对赌', '免佣百家乐', '极速模式', '真人荷官'],
  },
  {
    id: 'niu-niu',
    name: '牛牛',
    icon: 'ri-game-line',
    description: '趣味十足牛牛游戏，简单刺激的扑克比大小玩法',
    playerCount: '2-6人',
    difficulty: '简单',
    popularity: 90,
    image: 'https://readdy.ai/api/search-image?query=Exciting%20Chinese%20card%20game%20niuniu%20on%20red%20felt%20table%2C%20playing%20cards%20spread%20out%2C%20golden%20chips%2C%20warm%20festive%20atmosphere%2C%20traditional%20Chinese%20elements%2C%20gaming%20room%20with%20lanterns&width=800&height=600&seq=game-nn-01&orientation=landscape',
    features: ['经典牛牛', '百人牛牛', '看牌抢庄', '好友约局'],
  },
  {
    id: 'long-hu-dou',
    name: '龙虎斗',
    icon: 'ri-swap-line',
    description: '龙争虎斗，简单直观的比大小游戏，快节奏高刺激',
    playerCount: '多人',
    difficulty: '简单',
    popularity: 88,
    image: 'https://readdy.ai/api/search-image?query=Dragon%20tiger%20card%20game%20table%20with%20oriental%20dragon%20and%20tiger%20design%2C%20luxurious%20casino%20atmosphere%2C%20red%20and%20gold%20color%20theme%2C%20playing%20cards%2C%20golden%20chips%2C%20dramatic%20lighting&width=800&height=600&seq=game-lhd-01&orientation=landscape',
    features: ['龙虎对赌', '和局加倍', '极速开牌', '实时对战'],
  },
];

export const statsData = [
  { label: '累计注册用户', value: '5000万+', icon: 'ri-user-star-line', suffix: '' },
  { label: '日活跃玩家', value: '200万+', icon: 'ri-group-line', suffix: '' },
  { label: '累计发放奖励', value: '10亿+', icon: 'ri-money-cny-circle-line', suffix: '元' },
  { label: '游戏种类', value: '50+', icon: 'ri-gamepad-line', suffix: '款' },
];

export const advantages = [
  {
    title: '正版授权',
    description: '全部游戏均获得正版授权，合法合规运营，玩家权益有保障',
    icon: 'ri-shield-check-line',
  },
  {
    title: '公平公正',
    description: '采用国际认证的随机数生成算法，杜绝作弊，保证每一局公平',
    icon: 'ri-scales-3-line',
  },
  {
    title: '安全稳定',
    description: '银行级数据加密技术，多层安全防护体系，保障账号与资金安全',
    icon: 'ri-lock-line',
  },
  {
    title: '多端互通',
    description: '支持PC端、iOS、Android多平台登录，数据同步，随时随地畅玩',
    icon: 'ri-smartphone-line',
  },
  {
    title: '海量玩家',
    description: '5000万+注册用户在线匹配，秒速开局，不再等待',
    icon: 'ri-global-line',
  },
  {
    title: '24小时客服',
    description: '专业客服团队全天候在线，快速响应，解决您的每一个问题',
    icon: 'ri-customer-service-2-line',
  },
];

export const testimonials = [
  {
    name: '王先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20studio%20lighting%2C%20warm%20tone%2C%20simple%20background%2C%20friendly%20expression&width=200&height=200&seq=avatar-01&orientation=squarish',
    role: '资深玩家 · 3年',
    content: '开云棋牌是我用过最稳定的棋牌平台，游戏种类多，匹配速度快，客服响应也很及时。已经推荐给很多朋友了！',
    rating: 5,
    game: '斗地主爱好者',
  },
  {
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20female%20portrait%2C%20professional%20studio%20lighting%2C%20warm%20tone%2C%20simple%20background%2C%20confident%20smile&width=200&height=200&seq=avatar-02&orientation=squarish',
    role: '麻将达人 · 2年',
    content: '作为一个麻将爱好者，试过很多平台，最终选择了开云。界面美观，玩法丰富，四川麻将和广东麻将都能找到，太赞了！',
    rating: 5,
    game: '麻将玩家',
  },
  {
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%2C%20studio%20professional%20photography%2C%20warm%20lighting%2C%20clean%20background%2C%20casual%20confident%20look&width=200&height=200&seq=avatar-03&orientation=squarish',
    role: '竞技玩家 · 1年',
    content: '德州扑克的赛事体验真的不错，比赛奖池大，高手云集。平台的公平性让人放心，充值提现也很迅速。',
    rating: 4,
    game: '德州扑克玩家',
  },
  {
    name: '赵女士',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%2C%20studio%20photography%2C%20warm%20lighting%2C%20clean%20simple%20background%2C%20friendly%20approachable%20look&width=200&height=200&seq=avatar-04&orientation=squarish',
    role: '休闲玩家 · 半年',
    content: '平时工作压力大，下班后玩玩斗地主放松一下。开云的新手引导做得很贴心，上手快，福利活动也很多。',
    rating: 5,
    game: '休闲玩家',
  },
];

export const faqData = [
  {
    question: '开云棋牌如何注册账号？',
    answer: '点击官网或APP上的"注册"按钮，输入手机号码获取验证码，设置登录密码即可完成注册。注册即送新人大礼包，包含免费欢乐豆和专属优惠券。整个注册过程仅需1分钟。',
  },
  {
    question: '平台支持哪些支付方式？',
    answer: '开云棋牌支持微信支付、支付宝、银联卡、以及多种数字货币充值方式。充值秒到账，提现快速审核，保障您的资金安全。我们采用银行级加密技术确保每一笔交易安全可靠。',
  },
  {
    question: '如何保障游戏的公平性？',
    answer: '我们采用国际认证的随机数生成算法（RNG），所有游戏结果由独立算法生成，平台无法操控。同时定期接受第三方权威机构审计，确保每一局游戏都公平公正、公开透明。',
  },
  {
    question: '可以在哪些设备上玩？',
    answer: '开云棋牌支持PC电脑端（Windows/Mac）、iOS手机端、Android手机端、平板电脑等多种设备。一个账号多端互通，游戏进度和数据实时同步，随时随地畅享棋牌乐趣。',
  },
  {
    question: '遇到问题如何联系客服？',
    answer: '我们提供7×24小时在线客服服务。您可以通过APP内的"在线客服"功能、官方网站的"联系我们"页面、或拨打客服热线400-888-8888联系我们。专业客服团队将第一时间为您解决问题。',
  },
  {
    question: '新用户有哪些福利？',
    answer: '新用户注册即送豪华大礼包：包含88888免费欢乐豆、首充双倍返利、每日签到奖励、邀请好友双方得奖励等。此外还有不定期举办的赛事活动和限时福利，让您畅玩无忧。',
  },
];

export const articlesMock = [
  {
    id: 1,
    title: '斗地主高手进阶：七大技巧助你胜率翻倍',
    slug: 'dou-di-zhu-gao-shou-jin-jie-ji-qiao',
    excerpt: '想要在斗地主中脱颖而出？掌握这七个实用技巧，从叫地主到出牌策略全面升级，让你的胜率翻倍提升。',
    category: '游戏攻略',
    date: '2026-08-01',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20playing%20cards%20dou%20dizhu%20strategy%20scene%2C%20cards%20on%20wooden%20table%2C%20warm%20lighting%2C%20traditional%20Chinese%20style%2C%20game%20strategy%20atmosphere&width=600&height=400&seq=article-01&orientation=landscape',
    content: `斗地主作为中国最受欢迎的扑克游戏之一，看似简单，实则蕴含深奥的策略。本文将为你揭示七大高手必备技巧，帮助你在牌桌上游刃有余。

## 一、叫地主策略

叫地主是斗地主的第一道关卡。记住一个黄金法则：手中有大王+2或者至少两个2+一个A时，可以考虑叫地主。如果手中的牌比较散，不要勉强叫地主，当农民同样可以赢得精彩。

## 二、记牌技巧

高手之所以是高手，很大程度在于记牌能力。至少需要记住：大小王、2、A这三类关键牌。进阶玩家还可以记住K和Q的分布。记住出过的牌，能让你更好地判断对手手中的牌型。

## 三、出牌顺序

出牌顺序直接影响胜负。基本原则是：先出单牌试探，再出对子，最后出连牌。如果手中有炸弹，不要急于使用，留着作为威慑力量往往比实际打出更有价值。

## 四、农民配合

当农民时，与队友的配合至关重要。如果队友出了大牌，说明他想拿牌权，此时不要抢。学会"顶牌"——当地主出小牌时，用稍大的牌顶住，逼迫地主消耗大牌。

## 五、牌型判断

通过对手的出牌习惯和速度，可以推断他们的牌型。快速出牌通常意味着手中有好牌或炸弹；犹豫不决则可能在纠结如何拆牌。

## 六、炸弹的使用时机

炸弹是把双刃剑。最佳使用时机是：确信炸完后能拿到牌权并顺利走完剩余牌型，或者在关键时刻阻止地主逃跑。切勿为了炸而炸。

## 七、心态管理

保持良好的心态是长期稳定获胜的基础。输牌不气馁，赢牌不骄傲。遇到连败时，适当休息调整，以最佳状态重新出发。`,
  },
  {
    id: 2,
    title: '四川麻将vs广东麻将：地方玩法大比拼',
    slug: 'si-chuan-ma-jiang-vs-guang-dong-ma-jiang',
    excerpt: '四川麻将和广东麻将是中国最受欢迎的两种麻将玩法，它们在规则、番型和节奏上大不相同。一文带你全面了解两者的区别与魅力。',
    category: '游戏攻略',
    date: '2026-08-03',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Two%20styles%20of%20Chinese%20mahjong%20comparison%2C%20traditional%20mahjong%20tiles%20on%20green%20table%2C%20warm%20lighting%2C%20Chinese%20cultural%20elements%2C%20elegant%20gaming%20atmosphere&width=600&height=400&seq=article-02&orientation=landscape',
    content: `中国麻将文化博大精深，各地玩法各有特色。其中四川麻将和广东麻将是最受欢迎的两大流派，今天我们就来详细对比这两种经典玩法。

## 四川麻将特色

四川麻将又称"血战到底"，核心特点是"缺一门"——必须缺一种花色才能胡牌。四川麻将节奏快、对抗性强，一局常常打到最后一人，极具观赏性和竞技性。

四川麻将还有"刮风下雨"等独特的番型计算方式，杠牌可以立即收益，这增加了游戏的策略深度。玩家需要在攻守之间找到平衡。

## 广东麻将特色

广东麻将则以"推倒胡"为代表，规则相对灵活，胡牌方式多变。最大的特色是"鸡胡"——即使番数很低也能胡牌，这让游戏更加亲民，新手也能快速上手。

广东麻将还流行"买马"玩法，胡牌后可以根据买中的码数获得额外收益，增加了游戏的趣味性和变数。

## 选择建议

如果你喜欢快节奏、高对抗性的玩法，强烈推荐四川麻将；如果你偏爱灵活多变、轻松休闲的游戏体验，广东麻将会是更好的选择。当然，在开云棋牌，两种玩法都能畅享！`,
  },
  {
    id: 3,
    title: '德州扑克新手入门：从零开始学打牌',
    slug: 'de-zhou-pu-ke-xin-shou-ru-men',
    excerpt: '德州扑克是世界上最受欢迎的扑克游戏之一。这份新手完全指南将带你从零开始，了解规则、手牌排名和下注策略。',
    category: '新手教程',
    date: '2026-08-05',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Texas%20holdem%20poker%20learning%20scene%2C%20poker%20cards%20and%20chips%20on%20table%2C%20educational%20atmosphere%2C%20warm%20lighting%2C%20professional%20gaming%20setup&width=600&height=400&seq=article-03&orientation=landscape',
    content: `德州扑克是全球最受欢迎的扑克游戏，它融合了技巧、心理和运气的博弈。本文将为新手玩家提供一份完整的入门指南。

## 基础规则

德州扑克使用一副标准52张扑克牌。每位玩家会获得两张底牌（只有自己可见），然后桌面会依次翻开五张公共牌（所有人共用）。玩家需要从七张牌中选出最好的五张组合来比大小。

## 手牌排名（从大到小）

皇家同花顺 > 同花顺 > 四条 > 葫芦 > 同花 > 顺子 > 三条 > 两对 > 一对 > 高牌。记住这个排名是玩好德州扑克的基础。

## 下注轮次

游戏分为四个下注轮次：翻牌前（Pre-flop）、翻牌（Flop，三张公共牌）、转牌（Turn，第四张公共牌）、河牌（River，第五张公共牌）。每轮都可以选择跟注、加注、弃牌或过牌。

## 位置的重要性

在德州扑克中，位置（Position）是极其重要的概念。后位玩家可以观察前位玩家的行动后再做决定，因此处于有利位置。通常按钮位（庄家位）是最佳位置。

## 新手建议

刚开始玩时，建议只玩强手牌（如高对子、AK、AQ等），不要玩太多手牌。学会观察对手的下注模式，逐步积累经验。开云棋牌的新手桌是练习的最佳场所！`,
  },
  {
    id: 4,
    title: '开云棋牌平台安全体系全面解读',
    slug: 'kai-yun-qi-pai-an-quan-ti-xi',
    excerpt: '作为行业领先的棋牌平台，开云棋牌建立了全方位的安全防护体系。从数据加密到反作弊系统，一文读懂平台如何保障您的权益。',
    category: '平台动态',
    date: '2026-07-28',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Cybersecurity%20digital%20protection%20concept%2C%20shield%20and%20lock%20on%20digital%20background%2C%20warm%20golden%20tones%2C%20professional%20tech%20atmosphere%2C%20secure%20and%20reliable&width=600&height=400&seq=article-04&orientation=landscape',
    content: `在互联网时代，安全是每一位棋牌玩家最关心的问题。开云棋牌始终将用户安全放在首位，建立了五层安全防护体系。

## 第一层：数据加密

采用银行级SSL/TLS加密协议，所有用户数据传输均经过高强度加密处理，确保您的个人信息和交易数据不被窃取或篡改。

## 第二层：反作弊系统

引入AI智能反作弊引擎，实时监测异常游戏行为。任何作弊行为都会在第一时间被识别并处理，保障每一局的公平公正。

## 第三层：资金安全

所有玩家资金实行独立账户托管，与平台运营资金完全隔离。提现采用多重验证机制，确保每一笔资金都安全到达。

## 第四层：隐私保护

严格遵守国家个人信息保护法规，绝不泄露用户隐私数据。用户可以随时查看和管理自己的数据使用授权。

## 第五层：灾备系统

建立异地多活灾备中心，即使遇到极端情况也能确保服务不中断，数据不丢失，让您随时随地安心畅玩。`,
  },
  {
    id: 5,
    title: '棋牌游戏的社交魅力：不只是输赢',
    slug: 'qi-pai-you-xi-she-jiao-mei-li',
    excerpt: '棋牌游戏不仅仅是牌技的较量，更是社交的纽带。在开云棋牌，您不仅能体验对战的乐趣，还能结识来自五湖四海的朋友。',
    category: '玩家故事',
    date: '2026-07-25',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Friends%20playing%20cards%20together%20in%20cozy%20room%2C%20warm%20atmosphere%2C%20laughing%20and%20enjoying%2C%20social%20gaming%20scene%2C%20Chinese%20friends%20gathering&width=600&height=400&seq=article-05&orientation=landscape',
    content: `在快节奏的现代生活中，棋牌游戏承载着远超娱乐的社交价值。今天我们来聊聊棋牌游戏的社交魅力。

## 棋牌与传统文化

在中国传统文化中，棋牌一直是社交活动的重要载体。春节团圆打麻将、朋友聚会斗地主，棋牌连接着一代又一代人的情感。开云棋牌将这种传统社交体验搬到了线上。

## 语音聊天功能

开云棋牌的实时语音聊天功能让线上对战不再冰冷。边打牌边聊天，分享生活中的趣事，即使相隔千里也能感受到朋友就在身边。

## 好友系统

完善的好友系统让您轻松找到志同道合的牌友。邀请好友一起开房对战，组建自己的牌友圈。还可以加入公会，参与团队赛事。

## 线下活动的延伸

线上相识，线下相聚。我们定期举办的线下赛事和玩家聚会，让虚拟世界的友谊延伸到现实生活中。许多玩家在这里找到了真正的朋友甚至伴侣。

棋牌游戏的意义，远不止输赢那么简单。它连接着人与人之间的情感，传递着温暖与欢乐。`,
  },
  {
    id: 6,
    title: '2026年最受欢迎的五大棋牌游戏盘点',
    slug: '2026-zui-shou-huan-ying-qi-pai-you-xi',
    excerpt: '2026年棋牌游戏市场持续火爆，斗地主、麻将依然稳居榜首领跑。一起来看看今年最受欢迎的五大棋牌游戏。',
    category: '行业资讯',
    date: '2026-07-20',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Popular%20board%20and%20card%20games%20collection%2C%20various%20playing%20cards%20and%20game%20pieces%2C%20warm%20colorful%20arrangement%2C%20gaming%20lifestyle%20concept%2C%20top%20view&width=600&height=400&seq=article-06&orientation=landscape',
    content: `2026年即将过半，棋牌游戏市场持续繁荣。让我们一起来看看今年最受玩家欢迎的五大棋牌游戏。

## 第一名：斗地主

毫无悬念，斗地主继续领跑最受欢迎棋牌游戏榜单。简洁的规则、快速的节奏、极高的策略性，让斗地主成为全民游戏。开云棋牌的斗地主房间经常座无虚席。

## 第二名：麻将

作为国粹，麻将的魅力经久不衰。2026年麻将玩家人数再创新高，特别是四川麻将和广东麻将两个品类，热度持续攀升。

## 第三名：德州扑克

德州扑克在中国的发展势头强劲。越来越多的年轻人被其策略性和竞技性吸引，赛事规模和奖金也在不断增长。

## 第四名：牛牛

简单刺激的牛牛游戏异军突起，以其"秒速一局"的快节奏特点赢得了大量休闲玩家的喜爱。

## 第五名：百家乐

经典的百家乐凭借简洁优雅的玩法稳居前五。特别是真人荷官模式让在线体验无限接近线下赌场的真实感。`,
  },
];